import { ref } from 'vue'

/**
 * 递增后，依赖 readInjectedSignerAddress 的 computed 会重新求值。
 * selectedAddress / 多 Provider 晚于首帧就绪时，仅靠 store.account 可能长期不同步。
 */
export const injectSignerDisplayEpoch = ref(0)

export function bumpInjectSignerDisplayEpoch() {
  injectSignerDisplayEpoch.value += 1
}

function collectEthereumCandidates() {
  const out = []
  const seen = new Set()
  const push = (eth) => {
    if (!eth || typeof eth !== 'object') return
    if (seen.has(eth)) return
    seen.add(eth)
    out.push(eth)
  }
  try {
    if (typeof window === 'undefined') return out
    push(window.bitkeep && window.bitkeep.ethereum)
    const root = window.ethereum
    push(root)
    if (root && Array.isArray(root.providers)) {
      for (const p of root.providers) push(p)
    }
    if (root && root.provider) push(root.provider)
  } catch {
    void 0
  }
  return out
}

/**
 * 与 MetaMask / BitKeep 等注入钱包「顶栏已选账户」对齐的兜底读取。
 * 用于首帧 store 尚未写入时，兑换/跨链卡片与顶栏展示一致（链上操作仍以 store.account 为准）。
 */
export function readInjectedSignerAddress() {
  try {
    if (typeof window === 'undefined') return ''
    for (const eth of collectEthereumCandidates()) {
      const fromArr =
        eth &&
        Array.isArray(eth.accounts) &&
        eth.accounts[0] &&
        String(eth.accounts[0]).trim()
      if (fromArr) return String(fromArr).trim()
      const s = eth && typeof eth.selectedAddress === 'string' && eth.selectedAddress.trim()
      if (s) return String(s).trim()
    }
    return ''
  } catch {
    return ''
  }
}
